import { type SyncState } from '@prisma/client'
import { useTranslation } from 'react-i18next'
import { LinkButton } from '../button/link-button'
import { trackClick } from '~/utils/statistics/statistics.helper'

interface BookingButtonProps {
	eventDateId: string
	bookingLink?: string
	state?: SyncState
}

export default function BookingButton({
	eventDateId,
	bookingLink,
	state,
}: BookingButtonProps) {
	const { t } = useTranslation()
	const checkTicketReseller = (url?: string) => {
		if (!url) return undefined
		if (url.includes('tickster')) {
			return 'Tickster'
		} else if (url.includes('ticketmaster')) {
			return 'Ticketmaster'
		} else if (url.toLocaleLowerCase().includes('fever')) {
			return 'Fever'
		} else if (url.includes('billetto')) {
			return 'Billetto'
		} else {
			return undefined
		}
	}
	const ticketReseller = checkTicketReseller(bookingLink)
	const buttonText = ticketReseller
		? t('action_book_with', { reseller: ticketReseller })
		: t('action_read_more_and_book')
	return (
		state !== 'Cancelled' &&
		bookingLink && (
			<LinkButton
				variant="secondary"
				size="lg"
				className="align-center flex w-full"
				to={bookingLink}
				external
				onClick={() => trackClick(eventDateId, 'clicks')}
				rel="noopener external"
				target="_blank"
			>
				{buttonText}
			</LinkButton>
		)
	)
}
